import Switch from "react-switch";
import React from "react";
import {FormikErrors, FormikTouched} from "formik";

interface BYSwitchProps {
    title?: string;
    disabled?: boolean;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
    error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
    onChange?: (arg0: boolean) => void;
    checked?: boolean;
    required?: boolean;
    id?: string;
    themeColor?: 'green' | 'red';
}

const BYSwitch = (props: BYSwitchProps) => {
    const {title, disabled, touched, error, onChange, checked, required, id, themeColor = 'green'} = props;

    const displayError = touched && error;
    let color, shadowColor;

    if (themeColor === 'green') {
        color = '#86bc24';
        shadowColor = '0px 0px 1px 10px rgba(0, 0, 0, 0.2)';
    } else {
        color = '#dc3545';
        shadowColor = '0px 0px 1px 10px rgba(0, 0, 0, 0.2)';
    }

    return <>
        <div className="form-check form-switch">
            <Switch
                id={id}
                disabled={disabled}
                required={required}
                onColor={color}
                onHandleColor={color}
                handleDiameter={30}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow={shadowColor}
                height={20}
                width={48}
                onChange={onChange}
                checked={checked}/>
            {title && <label className={`form-check-label mx-1 cursor-pointer`}
                             onClick={() => onChange(!checked)}
                             style={checked ? {
                                 color
                             } : null}
                             htmlFor={id}>
                {' '}{title}
            </label>}
        </div>
        {displayError && <div className="text-danger font-weight-bold">{error}</div>}
    </>
};

export default BYSwitch;